import React from 'react';
import { routeConstants } from 'shared/constants';
import ProfileRoute from './screens/Profile/route';
import AddressRoute from './screens/Addresses/route';
import BusinessInfoRoute from './screens/BusinessInfo/route';
import ManageOrdersRoute from './screens/ManageOrders/route';
import WishlistRoute from './screens/Wishlist/route';
import OrderDetailsRoute from './screens/OrderDetails/route';
import ReviewsRoute from './screens/MyReviews/route';
const Account = React.lazy(() => import('./'));

const accountRoute = {
  ...routeConstants.ACCOUNT,
  component: Account,
  routes: [
    ProfileRoute,
    AddressRoute,
    ManageOrdersRoute,
    OrderDetailsRoute,
    WishlistRoute,
    ReviewsRoute,
    BusinessInfoRoute,
  ],
};

export default accountRoute;
